var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_vm.QR_STATE.show ? _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-guts",
    attrs: {
      "id": "qr-code"
    }
  }, [_c('div', {
    staticClass: "qr-code--container"
  }, [_c('div', {
    staticClass: "qr-code--frame"
  }, [_c('div', {
    staticClass: "qr-code--letter"
  }, [_c('span', [_vm._v(_vm._s(_vm.PROJECT_INFO.name && _vm.PROJECT_INFO.name.charAt(0)))]), _vm.PROJECT_INFO.attachment ? _c('div', {
    staticClass: "background cover",
    style: {
      backgroundImage: "url(".concat(_vm.PROJECT_INFO.attachment.link, ")")
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "qr-code--title"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.PROJECT_INFO.name)
    }
  })]), _c('div', {
    staticClass: "qr-code--code",
    class: !_vm.qr && 'rotating'
  }, [_vm.qr ? _c('img', {
    attrs: {
      "src": _vm.qr,
      "alt": _vm.$t('qr.code')
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "qr-code--data"
  }, [_vm.displayAmount ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.displayAmount)
    }
  }) : _vm._e(), _c('br'), _vm.QR_STATE.bill.description ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.QR_STATE.bill.description)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "qr-code--button figure",
    on: {
      "click": function click($event) {
        return _vm.SET_MODAL_PARAMS({
          type: 'QR',
          params: {
            show: false
          }
        });
      }
    }
  }, [_c('button', {
    staticClass: "icon",
    domProps: {
      "textContent": _vm._s(_vm.$t('common.close'))
    }
  })])]), _c('div', {
    staticClass: "qr-code--description"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('scan.qr.for.pay'))
    }
  })]), _c('div', {
    staticClass: "qr-code--buttons"
  }, [_c('a', {
    staticClass: "button thin clear",
    on: {
      "click": _vm.onDownload
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('download.svg')))])])]), _c('div', {
    staticClass: "qr-code--logo"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/logo-brand-colored.svg"),
      "alt": "Capusta Logo"
    }
  })])])])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }